module.exports = __webpack_public_path__ + "images/kaitori_bonus_lp/step-1-img-sp_0127d72de49dbac888eb4853225c6dd9.png";